import { render, staticRenderFns } from "./textarea-editor-tiptap.vue?vue&type=template&id=847a35b4&"
import script from "./textarea-editor-tiptap.vue?vue&type=script&lang=js&"
export * from "./textarea-editor-tiptap.vue?vue&type=script&lang=js&"
import style0 from "./textarea-editor-tiptap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VMenu})
